import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import ChangeSkin from '@wix/da-ds/pkg/Icons/24x24/ChangeSkin';
import {
  BiContextProvidedValue,
  BiData,
  ChangeBackgroundClickBiEvent,
} from '@wix/da-bi/pkg/events';
import { toggleSkinSelector } from '../../../../actions/profileSkins';
import { getProfileSkin } from '../../../../selectors/profileSkins';

interface Props {
  className?: string;
}
export const SkinButton: React.FC<Props> = ({ className }) => {
  const dispatch = useDispatch();
  const profileSkin = useSelector(getProfileSkin);
  return (
    <IconButtonWithBackground
      className={className}
      size="large"
      variant="edit-purple"
      icon={ChangeSkin}
      biData={BiData<ChangeBackgroundClickBiEvent>({
        evid: 370,
        background_name: profileSkin?.skinId ?? 'original',
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
        core_only: profileSkin?.isCore ? 1 : 0,
      })}
      onClick={() => dispatch(toggleSkinSelector())}
    />
  );
};

export default SkinButton;
